//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/check_box'
import 'devextreme/ui/date_box'
import 'devextreme/ui/radio_group'
import 'devextreme/ui/text_area'

//#endregion

import { USER_SESSION_SERVICE_NAME } from "../../../../../services/user-session"
import { IMRBaseComponent } from "../../../base"

import { ValveManageController } from "./action-run.dedicated.valve-manage.controller"
import { VALVE_MANAGE_SERVICE_NAME } from "./services"

export const COMPONENT_NAME: string = 'valveManage'

//#region Asset Imports

import './action-run.dedicated.valve-manage.scss'
import * as TEMPLATE from './action-run.dedicated.valve-manage.tpl.html'

//#endregion

export class ValveManageComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: ValveManageController,
            template: TEMPLATE,
            services: [VALVE_MANAGE_SERVICE_NAME, USER_SESSION_SERVICE_NAME]
        })
    }

}